import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { get, map } from 'lodash-es';

import reducer from './DocumentsBlock.reducer';
import { entryShape } from './DocumentsBlock.shape';
import { initializeState } from './DocumentsBlock.transform';
import { initializeQuestionsFormik } from './DocumentsBlock.utils';
import useReducer from '../../Utils/useReducer';

import './DocumentsBlock.scss';

const DocumentsBlockForm = ({
  initialState /* , formik: { values, errors, setFieldValue, isValid } */,
  eventEmitter,
}) => {
  const [state /* , dispatch */] = useReducer(reducer, initialState);

  const handleRoute = ({ url }) => {
    eventEmitter({ url });
  };

  return (
    <div className="documents-block-36aca1f7-aaed-4d15-928a-2dfa5196212d">
      {map(get(state, 'data.contracts', []), contract => (
        <div className="document" key={contract?.id}>
          {contract.component(contract.label)}
        </div>
      ))}
      {get(state, 'data.documents', []).length ? (
        map(get(state, 'data.documents', []), doc => (
          <div className="document" key={doc.id}>
            <div
              onClick={() => handleRoute({ url: '' })}
              onKeyPress={() => handleRoute({ url: '' })}
              role="link"
              tabIndex={0}
            >
              <div className="document-title" title="Document" />
              <div className="document-text">
                <div className="pdf-icon">PDF</div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="documents"></div>
      )}
    </div>
  );
};

DocumentsBlockForm.propTypes = {
  initialState: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  eventEmitter: PropTypes.func.isRequired,
  formik: PropTypes.shape({
    values: PropTypes.array, // eslint-disable-line react/forbid-prop-types
    errors: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    setFieldValue: PropTypes.func,
    isValid: PropTypes.bool,
  }).isRequired,
  strings: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

DocumentsBlockForm.defaultProps = {};

const DocumentsBlock = ({ data, eventEmitter, strings }) => {
  const initialState = initializeState({ data });

  return (
    <Formik
      initialValues={initializeQuestionsFormik(initialState?.data ?? {})}
      // update the Form `initialValues` with new value
      enableReinitialize
    >
      {({ setFieldValue, values, errors, isValid }) => (
        <DocumentsBlockForm
          initialState={initialState}
          formik={{ errors, setFieldValue, values, isValid }}
          eventEmitter={eventEmitter}
          strings={strings}
        />
      )}
    </Formik>
  );
};

DocumentsBlock.propTypes = {
  data: entryShape.isRequired,
  eventEmitter: PropTypes.func.isRequired,
  fieldChanged: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  }),
  strings: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

DocumentsBlock.defaultProps = {
  fieldChanged: {},
  strings: {},
};

export default DocumentsBlock;
